export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_CW_AGENCY_ENG-2f20827737f113dab7c922c916753f3e.pdf";